var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA4616",
    fillRule: "nonzero",
    d: "M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0Zm0 2C6.925 2 2 6.925 2 13s4.925 11 11 11 11-4.925 11-11S19.075 2 13 2Zm-.005 15.1c.452 0 .816.136 1.092.408.275.273.413.622.413 1.046 0 .419-.138.764-.413 1.037-.276.273-.64.409-1.092.409-.445 0-.806-.136-1.082-.409-.275-.273-.413-.618-.413-1.037 0-.418.138-.765.413-1.041.276-.276.637-.414 1.082-.414ZM14.425 6l-.315 9.596h-2.23L11.566 6h2.86Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorIcon);
export default ForwardRef;